import { Form, Col, Row } from 'react-bootstrap';

import { RequiredIndicator } from '../../styles';

const AsaasFields = ({ values, setFieldValue, touched, errors }) => {
  return (
    <Row>
      <Form.Group as={Col} lg="12" className="mb-3">
        <Form.Label>
          Token de Acesso
          <RequiredIndicator>*</RequiredIndicator>
        </Form.Label>
        <Form.Control
          type="text"
          name="access_token"
          value={values.access_token}
          onChange={e => setFieldValue('access_token', e.target.value)}
          isInvalid={touched.access_token && errors.access_token}
          placeholder="Chave de API"
        />
        <Form.Control.Feedback type="invalid">
          {errors.access_token}
        </Form.Control.Feedback>
      </Form.Group>
    </Row>
  );
};

export default AsaasFields;
